import { colors } from '@beelday/common'
import styled from '@emotion/styled'
import { FC, ReactNode } from 'react'
import { LobbySize, SCALE } from './lobby-size'

const List = styled.ul`
	margin: 0;
	padding: 0;
	list-style: none;
	display: flex;
	flex-direction: column;
	gap: 8px;
`

const Fact = styled.li<{ $size: LobbySize }>`
	display: flex;
	align-items: center;
	gap: 12px;
	color: ${colors.blackish};
	font-size: ${props => SCALE[props.$size].body}px;
	line-height: 1.4;
	overflow-wrap: anywhere;
`

const Leading = styled.span<{ $size: LobbySize }>`
	flex: none;
	width: ${props => SCALE[props.$size].badge}px;
	height: ${props => SCALE[props.$size].badge}px;
	overflow: hidden;
	border-radius: 50%;
`

export type FactItem = {
	id: string
	text: ReactNode
	/** A face before the line: the trainer's avatar. Decorative. */
	leading?: ReactNode
}

type Props = {
	size: LobbySize
	facts: FactItem[]
}

/** The short lines under the heading: who leads, when it starts or returns. */
export const LobbyFacts: FC<Props> = ({ size, facts }) =>
	facts.length > 0 ? (
		<List>
			{facts.map(fact => (
				<Fact key={fact.id} $size={size}>
					{fact.leading ? (
						<Leading $size={size} aria-hidden="true">
							{fact.leading}
						</Leading>
					) : null}
					<span>{fact.text}</span>
				</Fact>
			))}
		</List>
	) : null
